/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class FleetSnapshotController {
        public static $inject: string[] = [
            '$window',
            '$mobilityCompanyAuthentication',
            '$dealerwareLookerService',
            '$dealerwareInternationalizationData',
            'MicroFrontendOrigin'
        ];

        public collapsed: boolean;
        public loading: boolean;
        public available: any;
        public unavailable: any;
        public availableTotal: number;
        public unavailableTotal: number;
        public total: number;
        public utilization: string;
        public labels: {
            fleetStatus: any
        };

        constructor(public $window: any,
                    public $auth: any,
                    public $dealerwareLookerService: any,
                    public $dealerwareInternationalizationData: any,
                    public MicroFrontendOrigin: string) {
            this.getLabels('dashboard');
            this.loadData();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                }
            );
        }

        public vehiclesDashboard(status: string) : void {
            const newHash = `/vehicles/dashboard/${status}`;
            window.parent.postMessage({
                type: 'routing',
                hash: newHash
            }, this.MicroFrontendOrigin);
        }

        private get companyToken() : string {
            return this.$window.localStorage.getItem('company_token');
        }

        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }

        public loadData() : void {
            var _self = this;

            this.loading = true;
            this.available = {};
            this.unavailable = {};
            this.availableTotal = 0;
            this.unavailableTotal = 0;
            this.total = 0;
            this.utilization = undefined;

            this.$dealerwareLookerService.loadFleetSnapshot(this.companyToken, this.$auth.location.id).then(
                function(response: any) { _self.parseData(response.data); }
            ).finally(function() { _self.loading = false; });
        }

        public parseData(data: any) : void {
            var _self = this;

            $.each(data, function(idx: number, rec: any) {
                var state = rec['current_state'],
                    count = parseInt(rec['count']);

                switch (state) {
                    case "staged":
                    case "in_prep":
                    case "returned":
                        const lbl = _self.getStateLabelDict(state);
                        _self.available[state] = { count, label: lbl };
                        _self.availableTotal += count;
                        _self.total += count;
                        break;
                    case "rented":
                    case "maintenance":
                    case "hard_hold":
                    case "shuttle":
                        const lblU = _self.getStateLabelDict(state);
                        _self.unavailable[state] = { count, label: lblU };
                        _self.unavailableTotal += count;
                        _self.total += count;
                        break;
                }
            });

            this.utilization = this.total > 0 ? ((this.unavailable.rented.count || 0) / this.total * 100).toFixed(0) + '%' : 'N/A';
        }

        private getStateLabelDict(state: string) {
            const DEFAULT_LABEL = ''
            if (!this.labels) {
                return DEFAULT_LABEL;
            }
            
            return this.labels.fleetStatus[state];
        }

    }

    getDealerwareWebComponentsModule().controller('FleetSnapshotController', FleetSnapshotController);

    export class FleetSnapshotDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'FleetSnapshotController';
        public controllerAs     : string    =   'fleetSnapshotController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/fleet_snapshot/fleet_snapshot_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareFleetSnapshot",() => new FleetSnapshotDirective());
}
